module.exports = {
  title: 'Tornado',
  validators: {
    required: 'This field is required',
    passwordMustMatch: 'Passwords must match',
    invalidEmail: 'Invalid email address',
    maxLength: 'Field must not exceed {length} characters',
    minValue: 'Minimum allowed value is {value}',
    minArrayValue: 'Select at least {value} element | {value} elements',
    minValueExcluded: 'Value must be greater than {value}',
    maxValue: 'Maximum allowed value is {value}',
    maxValueExcluded: 'Value must be less than {value}',
    selectAtLeastOne: 'Select at least one option',
    firstName: 'First name is required',
    lastName: 'Last name is required',
    notAvailableAtThisDate: 'Not available on the specified date ({date})',
    priceIsNotSetAtThisDate: 'Price is not set for the specified date ({date})',
    requiredPriceDefinition: 'Price is not defined in the system',
    cashBoxAmountValidator: `Values in the 'Actual' column must be filled and not negative`,
  },
  errorMessages: {
    validators: {
      keys: {
        orderItems: `"Order list"`,
        privileges: `"Privilege list"`,
        overprice: `"Overprice"`,
        price: `"Price"`,
        wholesalePrice: `"Wholesale price"`,
        quantity: `"Quantity"`,
        discount: `"Discount"`,
        paginationSkip: `"Pagination skip"`,
        paginationTake: `"Pagination take"`,
        reviewStars: `"Review stars"`
      },
      ArrayMinSize: 'Minimum size of {key} must be greater than or equal to {value}',
      MinFieldEq: '{key} must be greater than or equal to {value}',
      MinExclude: '{key} must be greater than {value}',
      Min: '{key} must be greater than or equal to {value}',
      Max: '{key} must be less than or equal to {value}',
    },
    notFound: {
      keys: {
        user: 'user',
        home: '"Home" page',
        client: 'client',
        coupon: 'coupon',
        branch: 'branch',
        order: 'order',
        about: 'one of "About us" page',
        product: 'product',
        contact: 'contact',
        faq: 'one of "FAQ" page',
        request: 'request',
        funFact: 'one of "Fun fact" page',
        project: 'project',
        whyWe: 'one of "WhyWe" page',
        service: 'one of "Service" page',
        skillMain: '"Skill" page',
        staff: 'staff',
        skill: 'skill',
        socialLink: 'social link',
        userGroup: 'user group',
        testimonial: 'testimonial',
        productBrand: 'product brand',
        productReview: 'product review',
        productCategory: 'product category',
        mainCurrency: 'main currency',
        currency: 'currency',
        feature: 'condition',
        productReviewReply: 'reply of product review',
        productSubcategory: 'product subcategory',
        blog: 'blog',
        pricePolicy: 'price policy',
        productPrice: 'price of product',
        orderPayment: 'order payment',
        orderItem: 'order item',
        publicOffer: 'public offer',
        privacyPolicy: 'privacy policy'
      },
      message: 'The {key} was not found'
    },
    'Failed to fetch': 'You have connection issues, please check your internet and try again',
    FILE_FORMAT_IS_NOT_ALLOWED: 'This file type is not supported',
    FILE_SIZE_EXCEEDED_MAX_LIMIT: 'The file is too large to upload',
    CLIENT_ALREADY_EXISTS: 'The user with this email already exists in the system',
    INVALID_CREDENTIALS: 'The email or password you entered is incorrect',
    INVALID_REFRESH_TOKEN: 'Session expired or invalid Please log in again',
    RESET_TOKEN_FORBIDDEN: 'Password reset is not allowed for this account',
    BRANCH_ID_REQUIRED: 'Please select a branch to proceed',
    ORDER_CAN_NOT_BE_COMPLETED: 'This order cannot be completed at the moment',
    ORDER_CAN_NOT_BE_CANCELED: 'This order cannot be canceled',
    ORDER_CAN_NOT_BE_RETURNED: 'This order cannot be returned',
    INSUFFICIENT_ROLE: 'You don’t have the necessary permissions for this action',
    USER_GROUP_ALREADY_EXISTS: 'This user group already exists',
    USER_GROUP_CAN_NOT_BE_DELETED_BECAUSE_OF_ACTIVE_USERS: 'You cannot delete this group because it has active users',
    CAN_NOT_REMOVE_ACTUAL_USER: 'You cannot delete the currently logged-in user',
    INVALID_OWNERSHIP: 'You don’t have ownership rights for this action',
    INVALID_RESET_TOKEN: 'The password reset link is invalid or has expired',
    PRODUCT_CATEGORY_OR_SUBCATEGORY_REQUIRED: 'Required product category or subcategory',
    REQUIRED_LATIN_SYMBOLS: 'Required even 1 english letter in English title',
    CANNOT_REMOVE_LAST_ORDER_ITEM: 'Cannot remove, at least one item must remain in the order.',
    ORDER_HAS_ALREADY_LINKED_TO_CLIENT: 'This order already linked to client',
    blog_duplicate_title_en_idx: 'The blog title in English must be unique. Please choose a different title.',
    blog_duplicate_title_ru_idx: 'The blog title in Russian must be unique. Please choose a different title.',
    blog_duplicate_title_kg_idx: 'The blog title in Kyrgyz must be unique. Please choose a different title.',
    blog_duplicate_alt_idx: 'The blog slugify title must be unique. Please modify English title.',
    blog_time_to_read_gte_0: 'The blog reading time cannot be negative.',
    blog_word_count_gte_0: 'The word count of the blog cannot be less than zero',
    client_register_confirm_code_email_unique_idx: 'Registration failed because this email address is already registered.',
    client_reset_token_email_unique_idx: 'Password reset failed because there is already an active reset token for this email.',
    client_email_duplicate_idx: 'This email address is already in use. Please use a different email.',
    client_cart_product_duplicate_idx: 'You cannot add the same product to the cart more than once.',
    client_cart_quantity_gt_0: 'The quantity of items in the cart must be greater than zero.',
    client_wishlist_product_duplicate_idx: 'You cannot add the same product to the wishlist more than once.',
    branch_duplicate_title_en_idx: 'The branch title in English must be unique. Please choose a different title.',
    branch_duplicate_title_ru_idx: 'The branch title in Russian must be unique. Please choose a different title.',
    branch_duplicate_title_kg_idx: 'The branch title in Kyrgyz must be unique. Please choose a different title.',
    order_item_quantity_gt_0: 'The quantity of items in an order must be greater than zero.',
    order_item_price_gte_0: 'The price of an item in an order must be greater than or equal to zero.',
    order_total_price_gte_0: 'The total order price must be greater than or equal to zero.',
    order_price_without_coupon_limit: 'The order price without a coupon must be greater than or equal to the total price.',
    product_brand_duplicate_title_en_idx: 'The product brand title in English must be unique. Please choose a different title.',
    product_brand_duplicate_title_ru_idx: 'The product brand title in Russian must be unique. Please choose a different title.',
    product_brand_duplicate_title_kg_idx: 'The product brand title in Kyrgyz must be unique. Please choose a different title.',
    product_brand_duplicate_alt_idx: 'The product brand slugify title must be unique. Please modify English title.',
    product_category_duplicate_title_en_idx: 'The product category title in English must be unique. Please choose a different title.',
    product_category_duplicate_title_ru_idx: 'The product category title in Russian must be unique. Please choose a different title.',
    product_category_duplicate_title_kg_idx: 'The product category title in Kyrgyz must be unique. Please choose a different title.',
    product_category_duplicate_alt_idx: 'The product category slugify title must be unique. Please modify English title.',
    product_price_price_gte_0: 'The product price must be greater than or equal to zero.',
    product_price_overprice_limit: 'The overprice must either be null or greater than or equal to the regular price.',
    product_price_product_currency_uk: 'The product price must be unique for each currency.',
    product_subcategory_duplicate_title_en_idx: 'The product subcategory title in English must be unique. Please choose a different title.',
    product_subcategory_duplicate_title_ru_idx: 'The product subcategory title in Russian must be unique. Please choose a different title.',
    product_subcategory_duplicate_title_kg_idx: 'The product subcategory title in Kyrgyz must be unique. Please choose a different title.',
    product_subcategory_duplicate_alt_idx: 'The product subcategory slugify title must be unique. Please modify English title.',
    product_duplicate_title_en_idx: 'The product title in English must be unique. Please choose a different title.',
    product_duplicate_title_ru_idx: 'The product title in Russian must be unique. Please choose a different title.',
    product_duplicate_title_kg_idx: 'The product title in Kyrgyz must be unique. Please choose a different title.',
    product_duplicate_alt_idx: 'The product slugify title must be unique. Please modify English title.',
    product_quantity_gt_0: 'The product quantity must be null or greater than zero.',
    product_discount_limit: 'The product discount must either be null or a value between 0 and 1.',
    product_subcategory_or_category: 'A product must belong to either a category or a subcategory.',
    product_review_value_limit: 'The product review value must be greater than 0 and less than or equal to 5.',
    product_review_product_client_uk: 'You can not leave review, because you have already left',
    user_group_privilege_alt_duplicate_idx: 'The privilege alternative text must be unique.',
    user_email_duplicate_idx: 'This email address is already in the system. Please use a different email.',
    order_discount_limit: 'Order discount must be between 0 and 100'
  },
  toast: {
    imageUpdated: 'Image updated',
    imageDataUpdated: 'Image data updated',
    dataSaved: 'Data saved'
  },
  toolbar: {
    tabs: {
      admin: 'Administration',
      shop: 'Store'
    },
  },
  languages: {
    middle: {
      en: 'eng',
      ru: 'rus',
      kg: 'kgz'
    },
    long: {
      en: 'English',
      ru: 'Russian',
      kg: 'Kyrgyz'
    }
  },
  currency: {
    EUR: 'Euro',
    CNY: 'Chinese yuan',
    KZT: 'Kazakh tenge',
    KGS: 'Kyrgyz som',
    KRW: 'South Korean won',
    RUB: 'Russian ruble',
    TRY: 'Turkish lira',
    GBP: 'British pound',
    UZS: 'Uzbek sum',
    USD: 'United States dollar'
  },
  date: {
    months: {
      short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      full: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    },
    days: {
      short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    },
    times: {
      short: {
        days: 'd.',
        hours: 'h.',
        minutes: 'min.',
        seconds: 'sec.'
      }
    },
  },
  common: {
    loading: 'Loading',
    noData: 'No data',
    confirmDialog: 'Are you sure you want to proceed with this operation?',
    deletionConfirmation: 'Are you sure you want to delete?',
    softDeletionConfirmation: 'Are you sure you want to show/hide?',
    oops: 'Oops',
    accessDenied: 'Access denied',
    pageNotFound: 'Page not found',
    pc: 'pc',
    none: 'None'
  },
  types: {
    system: {
      RIG: 'tornado.kg',
      SHOP: 'store.tornado.kg'
    },
    project: {
      IMAGE: 'Image',
      YOUTUBE: 'Youtube'
    },
    productStatuses: {
      IN_STOCK: 'In stock',
      OUT_OF_STOCK: 'Out of stock',
      ON_ORDER: 'On order',
      COMING_SOON: 'Awaiting delivery',
    },
    productTags: {
      SALE: 'Sale',
      NEW: 'New',
      HOT: 'Hot',
      EXCLUSIVE: 'Exclusive',
      LIMITED: 'Limited',
      BEST_PRICE: 'Best price'
    },
    paymentTypes: {
      CASH: 'Cash',
      NON_CASH: 'Non cash'
    },
    discountTypes: {
      WHOLESALE: 'Bulk',
      SALE: 'Sale',
      COUPON: 'Coupon',
      PRICE_POLICY: 'Price policy'
    },
    orderStatuses: {
      PENDING: 'Pending',
      PREPARING: 'Preparing',
      READY: 'Ready',
      IN_DELIVERY: 'In delivery',
      DELIVERED: 'Delivered',
      COMPLETED: 'Completed',
      RETURNED: 'Returned',
      CANCELED: 'Canceled'
    },
    orderStatusPayments: {
      NO: 'Not paid',
      PART: 'Partially paid',
      YES: 'Fully paid'
    },
    cashOnsInfo: {
      DELIVERY: 'Payment upon',
      CHECK: 'Payment by',
      SELF_DELIVERY: 'Payment upon'
    },
    clientTypes: {
      REGULAR: 'Regular client',
      WHOLESALER: 'Wholesaler',
      ADMIN: 'Admin',
      LOYAL: 'Loyal client'
    },
    nodePositions: {
      LEFT: 'Left',
      RIGHT: 'Right',
      CENTER: 'Center',
      LEFT_WITH_TEXT: 'Left with text',
      RIGHT_WITH_TEXT: 'Right with text'
    }
  },
  auth: {
    login: 'Login',
    loggingOut: 'Logging out...',
    passwordRecovery: 'Password Recovery',
    rememberYourPassword: 'Remember your password?',
    instructionDescription: 'Password recovery instructions have been sent. Please check your email',
    goToLoginScreen: 'Go to login screen',
    passwordRecoveryConfirmation: 'Password Recovery Confirmation',
    invalidResetTokenDescription: 'Invalid token. Please try to recover your password again',
    goToPasswordRecoveryScreen: 'Go to password recovery screen',
    changePassword: 'Change password',
    yourPasswordSuccessfullyChanged: 'Your password has been changed successfully',
  },
  pages: {
    pages: 'Pages',
    home: 'Home',
    aboutUs: 'About us',
    whyWe: 'Why we',
    services: 'Services',
    features: 'Conditions',
    contacts: 'Contacts',
    socialLinks: 'Social links',
    portfolio: 'Portfolio',
    skills: 'Skills',
    testimonials: 'Testimonials',
    funFacts: 'Achievements',
    faq: 'FAQ',
    team: 'Team',
    userManagement: 'User Management',
    users: 'Users',
    userGroups: 'User groups',
    mainDescription: 'Select the configuration you need',
    settings: 'Settings',
    currencies: 'Currencies',
    pricePolicy: 'Price policy',
    publicOffer: 'Public offer',
    privacyPolicy: 'Privacy policy'
  },
  shop: {
    orders: 'Orders',
    products: 'Products',
    blog: 'Blog',
    clients: 'Clients',
    requests: 'Requests',
    tornado: 'Tornado',
    shop: 'Store',
    settings: 'Settings',
    productsCategories: `Products' categories`,
    productsSubcategories: `Products' subcategories`,
    productsBrands: `Products' brands`,
    coupons: 'Coupons',
    branches: 'Branches',
    requestsFromTornado: 'Requests from tornado.kg',
    requestsFromShop: 'Requests from store.tornado.kg',
    shownInDetails: 'will be shown in details',
    productReviews: 'Product reviews',
  },
  modals: {
    user: {
      add: 'Add new user',
      edit: 'Edit user'
    },
    userGroup: {
      add: 'Add new group',
      edit: 'Edit group'
    },
    aboutUs: {
      add: 'Add new about us',
      edit: 'Edit about us'
    },
    whyWe: {
      add: 'Add new why we',
      edit: 'Edit why we'
    },
    service: {
      add: 'Add new service',
      edit: 'Edit service'
    },
    feature: {
      add: 'Add new condition',
      edit: 'Edit condition'
    },
    product: {
      add: 'Add new product',
      edit: 'Edit product',
      updateImages: 'Update images of product'
    },
    blog: {
      add: 'Add new blog',
      edit: 'Edit blog',
      updateImages: 'Update images of product'
    },
    project: {
      add: 'Add new project',
      edit: 'Edit project'
    },
    testimonial: {
      add: 'Add new testimonial',
      edit: 'Edit testimonial'
    },
    skill: {
      add: 'Add new skill',
      edit: 'Edit skill'
    },
    contact: {
      add: 'Add new contact',
      edit: 'Edit contact'
    },
    socialLink: {
      add: 'Add new social link',
      edit: 'Edit social link'
    },
    faq: {
      add: 'Add new FAQ',
      edit: 'Edit FAQ'
    },
    funFact: {
      add: 'Add new achievement',
      edit: 'Edit achievement'
    },
    staff: {
      add: 'Add new staff',
      edit: 'Edit staff'
    },
    client: {
      add: 'Add new client',
      edit: 'Edit client',
      ban: 'Are you sure you want to ban this client?',
      unban: 'Are you sure you want to unban this client?'
    },
    productBrand: {
      add: 'Add new product brand',
      edit: 'Edit product brand'
    },
    productCategory: {
      add: 'Add new product category',
      edit: 'Edit product category'
    },
    productSubcategory: {
      add: 'Add new product subcategory',
      edit: 'Edit product subcategory'
    },
    branch: {
      add: 'Add new branch',
      edit: 'Edit branch'
    },
    coupon: {
      add: 'Add new coupon',
      edit: 'Edit coupon'
    },
    request: {
      info: `Request's information`,
      fromSystem: 'From system',
      notAnswered: 'Not yet answered',
      answered: 'Already answered'
    },
    currency: {
      add: 'Add new currency',
      edit: 'Edit currency'
    },
    order: {
      edit: 'Edit order',
      return: 'Return order',
      cancel: 'Cancel order',
      returnInfo: 'Are you sure you want to return order? Please, write the reason of this action:',
      cancelInfo: 'Are you sure you want to cancel order? Please, write the reason of this action:',
      complete: 'Do you want to complete order?',
      status: 'Change order status',
      paymentAdd: 'Add payment',
      paymentEdit: 'Edit payment',
      itemAdd: 'Add product to order',
      itemEdit: 'Edit product of order',
      statusInfo: 'Order status',
      statusPaymentInfo: 'Order payments',
      orderItems: 'Products of order',
      details: 'Details of order',
      linkOrderToClient: 'Link order to client'
    },
    pricePolicy: {
      add: 'Add new price policy',
      edit: 'Edit price policy'
    },
    productReview: {
      edit: 'Edit product review',
      replies: 'Review replies',
      editReply: 'Edit product review reply'
    },
  },
  userGroups: {
    manager: 'Manager',
    admin: 'Administrator',
    other: 'Other',
  },
  editor: {
    default: 'Default',
    defaultShort: 'def',
    byDefault: 'Default',
    bold: 'Bold',
    italic: 'Italic',
    strikethrough: 'Strikethrough',
    underline: 'Underline',
    heading: 'Heading',
    normalText: 'Normal text',
    heading1: 'Heading 1',
    heading2: 'Heading 2',
    heading3: 'Heading 3',
    heading4: 'Heading 4',
    heading5: 'Heading 5',
    heading6: 'Heading 6',
    fontSize: 'Font size',
    increaseFontSize: 'Increase font size',
    decreaseFontSize: 'Decrease font size',
    textColor: 'Text color',
    highlightColor: 'Highlight color',
    align: 'Align',
    leftAlign: 'Left align',
    centerAlign: 'Center align',
    rightAlign: 'Right align',
    justify: 'Justify',
    fontStyle: 'Font style',
    lineSpacing: 'Line spacing',
    checklist: 'Checklist',
    bulletedList: 'Bulleted list',
    numberedList: 'Numbered list',
    horizontalRule: 'Horizontal rule',
    blockquote: 'Blockquote',
    code: 'Code',
    codeBlock: 'Code Block',
    hyperlink: 'Hyperlink',
    table: 'Table',
    editTable: 'Edit table',
    insertTable: 'Insert table',
    removeTable: 'Remove table',
    toggleHeaderRow: 'Toggle header row',
    toggleHeaderColumn: 'Toggle header column',
    toggleHeaderCell: 'Toggle header cell',
    insertColumnLeft: 'Insert column left',
    insertColumnRight: 'Insert column right',
    removeSelectedColumns: 'Remove selected columns',
    insertRowUp: 'Insert row up',
    insertRowDown: 'Insert row down',
    removeSelectedRows: 'Remove selected rows',
    mergeCells: 'Merge cells',
    splitCell: 'Split cell',
    cellColor: 'Cell color',
    insertImage: 'Insert image',
    insertVideo: 'Insert video',
    insertYoutubeVideo: 'Insert Youtube video',
    addEmoji: 'Add emoji',
    undo: 'Undo',
    redo: 'Redo'
  },
  fileBrowser: {
    deletion: 'Deletion',
    selectFolderOrFile: 'Select a folder or a file',
    noFilesOrFoldersFound: 'No files or folders found',
    folderIsEmpty: 'The folder is empty',
    deleteDescription: 'Are you sure you want to delete <b>{type}</b>?<br><em>{baseName}</em>',
    thisFolder: 'this folder',
    thisFile: 'this file',
    upTo: 'Up to: {value}',
    uploadTo: 'Upload to:',
    maxFilesCount: 'Max files count: {value}',
    maxFileSize: 'Max file size: {value}',
  },
  formLabels: {
    file: 'File',
    size: 'Size',
    filter: 'Filter',
    from: 'From',
    to: 'To',
    sum: 'Amount',
    currency: 'Currency',
    paymentType: 'Payment type',
    discountType: 'Discount type',
    notes: 'Notes',
    enterComment: 'Enter comment',
    date: 'Date',
    searchByTitle: 'Search by title',
    refund: 'Refund',
    cashBox: 'Cash box',
    title: 'Title',
    firstName: 'First name',
    lastName: 'Last name',
    telNumber: 'Tel. number',
    email: 'Email',
    userGroup: 'User group',
    privileges: 'Privileges',
    yourEmail: 'Your email',
    password: 'Password',
    enterYourEmail: 'Enter your email',
    enterNewPassword: 'Enter new password',
    confirmYourNewPassword: 'Confirm your new password',
    subtitle: 'Subtitle',
    location: 'Location',
    coverImage: 'Cover image',
    backgroundImage: 'Background image',
    shopBackgroundImage: `Store's background image`,
    primaryLogo: 'Primary logo',
    secondaryLogo: 'Secondary logo',
    primaryShopLogo: 'Store\'s primary logo',
    secondaryShopLogo: 'Store\'s secondary logo',
    description: 'Description',
    quote: 'Quote',
    experienceYear: 'Experience from (ex. 2010)',
    showInHome: `Use it in 'Home' page`,
    isAboutPage: `Use it in 'About us' page`,
    isWhyWe: `Use it in 'Why we' section`,
    symbolLeft: 'Symbol in left of price',
    example: 'Example',
    exampleVideoUrl: 'Get 11-char code from the link as shown below by red font and enter to the field',
    profession: 'Profession',
    image: 'Image',
    tags: 'Short comments',
    blogTags: 'Tags (divide by commas)',
    keywordsBlogHint: 'Specify 3–5 unique and relevant words for this blog that reflect its topic. Separate them with commas without spaces.',
    keywordsProductHint: 'Specify 3–5 unique and relevant words for this product that describe it. Separate them with commas without spaces.',
    isService: `Use it in 'Service' page`,
    videoImage: 'Video image',
    urlVideo: 'Id from the video link (youtube)',
    percent: 'Percent',
    telegram: 'Telegram link',
    whatsapp: 'Whatsapp link',
    showInSites: 'Show in sites',
    showInAbouts: 'Show in "About us"',
    iconSearchHint: 'Icons can be searched:',
    here: 'here',
    mainContact: 'Main contact',
    leftImage: 'Left image',
    rightImage: 'Right image',
    value: 'Value',
    url: 'Link',
    icon: 'Icon',
    category: 'Category',
    subcategory: 'Subcategory',
    productCategoryInfo: 'Choose either subcategory, or category',
    projectType: 'Portfolio type',
    name: 'Name',
    comment: 'Comment',
    position: 'Position',
    question: 'Question',
    answer: 'Answer',
    fullName: 'Full Name',
    fullNameEmailTelNumberSearch: 'Search by name, email or tel.',
    admin: 'Admin',
    address: 'Address',
    clientId: 'Client ID',
    deliveryPrice: 'Delivery price',
    code: 'Code',
    validTo: 'Valid to',
    validFrom: 'Valid from',
    discountPercent: 'Discount in percent',
    message: 'Message',
    language: 'Language',
    descriptionShort: 'Short description',
    brand: 'Brand',
    onlineShopSection: 'Section of online-store',
    otherImages: 'Other images',
    addImage: 'Add new image',
    productExample: 'Example of product in different languages and currencies',
    price: 'Price',
    overprice: 'Overprice',
    showInShop: 'Show in online-store',
    homeBanner: 'Show in store banner',
    inStock: 'In stock',
    quantity: 'Quantity',
    mainCurrency: 'Main currency',
    symbol: 'Symbol',
    status: 'Status',
    tag: 'Tag',
    link: 'Link',
    delivery: 'Delivery',
    orderNumber: 'Order number',
    cashOn: 'Cash on',
    statusPayment: 'Status of payment',
    registeredAt: 'Registered at',
    client: 'Client',
    branch: 'Branch',
    order: 'Order',
    usedCoupon: 'Used coupon',
    deliveryTo: 'Delivery to',
    selfDeliveryFrom: 'Self-delivery from',
    total: 'Total',
    paymentIs: 'Payment is',
    paymentLeft: 'Payment left',
    paid: 'Paid',
    orderIs: 'Order is',
    totalCount: 'Total items',
    totalQuantity: 'Total quantity',
    reason: 'Reason',
    orderNumOrClient: 'Order № or client name, phone, email',
    titleOrClient: 'Title or client name',
    content: 'Content',
    public: 'Public post',
    author: 'Author',
    enterUrl: 'Enter a URL',
    enterEmbedUrl: 'Enter youtube video code (11 characters)',
    showInClientAddress: 'Show in client address section',
    wholesalePrice: 'Wholesale price',
    fromPrice: 'Price from',
    forClients: 'For clients',
    type: 'Type',
    productDiscountHint: 'Discount works only on "Sale" tag',
    productWholesalePriceHint: 'If empty, wholesalers will see common price',
    product: 'Product',
    createdAt: 'Created at',
    rating: 'Rating',
    productTitle: `Product's title`,
    thesis: 'Thesis',
    widthInPercent: 'Width in %',
    nodePosition: 'Position',
    youtubeDescription: 'This is just a container for a YouTube video, and this is how much space it takes. You don’t see the actual video, but it’s here. If you entered the correct ID, it will work. Click the link—if it works, that means it\'s correct.',
    autoUse: 'Automatically use to orders',
    firstOrder: 'For first orders',
    toBanner: 'Show in banner',
    wideImage: 'Wide image',
    mobileImage: 'Vertical image',
    wholesale: 'bulk',
    clientNotes: 'Client notes',
    amount: 'Sum',
    couponBannerWideImageHint: `<b>Perfect banner - </b>16:9<br/>
Restricted areas - these areas are at risk of being invisible on different screens. Try to leave them "empty."`,
    couponBannerMobileImageHint: `<b>Perfect banner for vertical screens (2 images)</b>:<br/>
For vertical screens (mobile phones): width/height = 0.525 (e.g., width = 420px, height = 800px, ratio = 0.525)<br/>
<b>Simply put, a 9:16 ratio will work.</b>`,
    warningOrderItems: 'Warning! Danger zone! If you want to change product prices or affect the total cost (e.g., add or remove items from the order), make sure you have the customer\'s approval.',
    clientNotRegistered: 'Not registered client',
    titleOrId: 'Title or article (ID)'
  },
  table: {
    id: 'ID',
    fullName: 'Full Name',
    email: 'Email',
    telNumber: 'Tel. Number',
    userGroup: 'User Group',
    active: 'Active',
    privileges: 'Privileges',
    title: 'Title',
    actions: 'Actions',
    type: 'Type',
    subtitle: 'Subtitle',
    price: 'Price',
    category: 'Category',
    profession: 'Profession',
    amount: 'Sum',
    paymentType: 'Payment type',
    currency: 'Currency',
    num: '№',
    supervisor: 'Supervisor',
    executor: 'Executor',
    where: 'Where',
    description: 'Description',
    createdAt: 'Created at',
    deadline: 'Deadline',
    status: 'Status',
    priority: 'Priority',
    number: 'Room',
    numberType: 'Room type',
    cleaning: 'Cleaning',
    checkIn: 'Check in',
    checkOut: 'Check out',
    guestFullName: 'Guest name',
    cleanerFullName: 'Cleaner name',
    adults: 'Adults',
    children: 'Children',
    bookingStatus: 'Booking status',
    numberStatus: 'Room status',
    notes: 'Notes',
    expFrom: 'Experience from',
    isAboutPage: `About us' page`,
    showInHome: `Home' page`,
    isService: `Service' page`,
    percent: 'Percent',
    telegram: 'Telegram',
    whatsapp: 'Whatsapp',
    showIn: 'Show in',
    isMain: 'Is main',
    value: 'Value',
    name: 'Name',
    position: 'Position',
    question: 'Question',
    admin: 'Admin',
    banned: 'Banned',
    address: 'Address',
    discount: 'Discount',
    validTo: 'Valid',
    fromSite: 'From site',
    mainCurrency: 'Main currency',
    symbol: 'Symbol',
    usingInSystem: 'Using in system',
    code: 'Code',
    showInShop: 'Shown in online-store',
    tag: 'Tag',
    client: 'Client',
    cashOn: 'Cash on',
    payment: 'Payment left',
    delivery: 'Delivery',
    registeredAt: 'Registered at',
    orderNum: 'Order №',
    yes: 'Yes',
    no: 'No',
    rating: 'Rating',
    product: 'Product',
    timeToRead: 'Time to read',
    words: 'Words count',
    minRead: 'min read',
    public: 'Public',
    wholesale: 'wholesale',
    fromPrice: 'Price from',
    forClients: 'For clients',
    quantity: 'Quantity',
    repliesCount: 'Replies',
    comment: 'Comment',
    tags: 'Tags',
    from: 'from',
    to: 'to',
    discountType: 'Discount type',
    pricePriceDiscount: 'Price (price without discount)',
    paid: 'Paid'
  },
  buttons: {
    selectAll: 'Select all',
    reload: 'Reload',
    logout: 'Logout',
    disclose: 'Disclose',
    close: 'Close',
    reset: 'Reset',
    form: 'Generate',
    remove: 'Remove',
    delete: 'Delete',
    recover: 'Recover',
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add',
    back: 'Back',
    edit: 'Edit',
    view: 'View',
    movement: 'Move',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    payment: 'Payment',
    invoiceForPayment: 'Invoice for Payment',
    invoice: 'Invoice',
    confirmationInvoice: 'Booking Confirmation',
    addPayment: 'Add Payment',
    closeShift: 'Close Shift',
    sendToCashBox: 'Send to cash-box',
    transferShift: 'Shift-Handover',
    collectionShift: 'Collect cash',
    submit: 'Submit',
    getShift: 'Take shift',
    send: 'Send',
    openShift: 'Open shift',
    collect: 'Collect',
    actions: 'Actions',
    forgotYourPassword: 'Forgot your password?',
    login: 'Login',
    ban: 'Ban',
    unban: 'Unban',
    yes: 'Yes',
    clear: 'Clear',
    makeAnswered: 'Make answered',
    answerLater: 'Answer later',
    confirm: 'Confirm',
    details: 'Details',
    use: 'Use',
    unuse: `Don't use`,
    menu: 'Menu',
    changeStatus: 'Change status',
    showPayments: 'List of payments',
    showItems: 'List of products',
    complete: 'Complete',
    return: 'Return',
    images: 'Images',
    enterImageUrl: 'Enter an image URL',
    enterVideoUrl: 'Enter a video URL',
    select: 'Select',
    createFolder: 'Create folder',
    uploadFiles: 'Upload files',
    addFiles: 'Add files',
    upload: 'Upload',
    link: 'Link',
    unlink: 'Unlink',
    showReplies: 'Show replies',
    linkToClient: 'Link to client'
  },
  $vuetify: {
    badge: 'Badge',
    close: 'Close',
    dataIterator: {
      noResultsText: 'No matching records found',
      loadingText: 'Loading items...',
    },
    dataTable: {
      itemsPerPageText: 'Rows per page:',
      ariaLabel: {
        sortDescending: 'Sorted descending.',
        sortAscending: 'Sorted ascending.',
        sortNone: 'Not sorted.',
        activateNone: 'Activate to remove sorting.',
        activateDescending: 'Activate to sort descending.',
        activateAscending: 'Activate to sort ascending.',
      },
      sortBy: 'Sort by',
    },
    dataFooter: {
      itemsPerPageText: 'Items per page:',
      itemsPerPageAll: 'All',
      nextPage: 'Next page',
      prevPage: 'Previous page',
      firstPage: 'First page',
      lastPage: 'Last page',
      pageText: '{0}-{1} of {2}',
    },
    datePicker: {
      itemsSelected: '{0} selected',
      nextMonthAriaLabel: 'Next month',
      nextYearAriaLabel: 'Next year',
      prevMonthAriaLabel: 'Previous month',
      prevYearAriaLabel: 'Previous year',
    },
    noDataText: 'No data available',
    carousel: {
      prev: 'Previous visual',
      next: 'Next visual',
      ariaLabel: {
        delimiter: 'Carousel slide {0} of {1}',
      },
    },
    calendar: {
      moreEvents: '{0} more',
    },
    input: {
      clear: 'Clear {0}',
      prependAction: '{0} prepended action',
      appendAction: '{0} appended action',
    },
    fileInput: {
      counter: '{0} files',
      counterSize: '{0} files ({1} in total)',
    },
    timePicker: {
      am: 'AM',
      pm: 'PM',
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Pagination Navigation',
        next: 'Next page',
        previous: 'Previous page',
        page: 'Goto Page {0}',
        currentPage: 'Current Page, Page {0}',
      },
    },
    rating: {
      ariaLabel: {
        icon: 'Rating {0} of {1}',
      },
    },
    loading: 'Loading...',
  },
};
